<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page title=" Katalog Semen Negeri">
      <div class="table_scrol">
        <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
            <w-flex class="mt3">
              <w-input style="margin:5px; " v-model="pencarian.kode" label="ID Ternakan" />
              <w-input style="margin:5px; " v-model="pencarian.nama" label="Nama Ternakan" />
              <z-select style="margin:5px; " v-model="pencarian.lkp_baka_id" :items="lkp_baka" label="Baka" />
              <z-select style="margin:5px; " v-model="pencarian.jantina" :items="jantina" label="Jantina" />
            </w-flex>
          </w-form>
          <w-flex justify-end class="mt2">
                      <w-button bg-color="success" v-on="on" @click="cetak()" class="mr2">
                    <w-icon class="mr1" md >fal fa-print</w-icon>CETAK
                </w-button>
                      <w-button class="mr2" v-on:click="resetPencarian()" v-on="on" bg-color="warning">
                    <w-icon class="mr1" md >fal fa-redo</w-icon>SET SEMULA
                </w-button>
                      <w-button class="mr2" bg-color="primary"  v-on="on" @click="$refs.frm.validate()"> 
                    <w-icon class="mr1" md >fal fa-search</w-icon>CARI
                </w-button>
          </w-flex>
        </div>
  		 <z-table title="Senarai Katalog Semen Negeri" :headers="table.headers" :items="table.items" :meta="table.meta">
         <template #button v-if="$zutil.anyRole(['4'])">
                     <w-button class="action-btn print" @click="katalogPrint()">
                         <w-icon  class="mr2" xs>fal fa-print</w-icon>CETAK KATALOG
                     </w-button>
                     <template v-if="$zutil.anyRole(['4'])">
                        <template v-if="$zutil.anyCan(['3'])">
                           <inertia-link :href="$route('se.stpp_katalog.form',0)" v-on="on" class="w-button green--bg  w-button--dark size--md  ml1"> 
                              <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                            </inertia-link>
                        </template>
                        <template v-else-if="$zutil.anyCan(['3'])">
                           
                        </template>
                     </template>
                     <template v-else>
                        <inertia-link :href="$route('se.stpp_katalog.form',0)" v-on="on" class="w-button green--bg  w-button--dark size--md  ml1"> 
                           <w-icon class="mr1" md >fal fa-plus</w-icon>TAMBAH
                        </inertia-link>
                     </template>
                     </template>
              		<template #header-label="{ header, label, index }">
        		  <template v-if="header.key == 'action'"> TINDAKAN </template>
        		<template v-else> {{ label }} </template>
        	 </template>
          <template #item-cell.action="{ item, label, header, index }">
  		      <w-flex class="flex justify-center">
               <w-tooltip md top color="white" bg-color="black" >
                <template #activator="{ on }">
                      <inertia-link :href="$route('se.stpp_katalog.show',item.id)"  v-on="on" class="w-button w-button--dark size--md info-dark1--bg"><div style="width: 6px"></div> 
                    <w-icon class="mr1" md >fal fa-eye</w-icon>
                </inertia-link>
                </template>
               PAPAR
              </w-tooltip>
              &nbsp;
              <template v-if="$zutil.anyRole(['4'])">
                <template v-if="$zutil.anyCan(['3'])">
                  <w-tooltip md top color="white" bg-color="black">
                      <template #activator="{ on }">
                            <w-button  bg-color="warning" v-if="item.hantar !=1" :route="$route('se.stpp_katalog.form',item.id)" v-on="on" class="be fs-2"><div style="width: 6px"></div> 
                          <w-icon class="mr1" md >fal fa-pencil</w-icon>
                      </w-button>
                      </template>
                     KEMASKINI
                  </w-tooltip>
                  &nbsp;
                  <w-tooltip md top color="white" bg-color="black">
                      <template #activator="{ on }">
                            <w-button class="fs-2" v-on="on" v-if="item.padam == 1 " bg-color="error-dark1" dark tile @click="destroy1(item.id)"><div style="width: 6px"></div> 
                          <w-icon class="mr1" md >fal fa-trash</w-icon>
                      </w-button>
                      </template>
                     PADAM
                  </w-tooltip>
                </template>
              </template>
  		      </w-flex>
  		    </template>
  		  </z-table>
      </div>
	 </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'se.stpp_katalog',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Katalog Semen Negeri', route: '/se/stpp_katalog' },
      ],
      pencarian: {
         kode: '',
         lkp_ternakan_id: '',
         lkp_baka_id: '',
         jantina: '',
      },
      lkp_ternakan: [],
      lkp_baka: [],
      jantina:[],
    }
  },
  methods: {
    cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },
    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },

    getBaka(){
      this.$zcomm.get(this.api_service + 'lookup/baka_all', {}).then(res => {
        this.lkp_baka = res
      })
    },

    destroy1(id)
    {
      this.$swal({
        title: 'Anda Pasti?',
        // text: "Are you sure want to delete this item!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete(this.resourceurl + '.destroy',id)
          .then(res => {
            this.sending = false;
            this.$inertia.visit(this.$page.url)
            this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
              this.onAfterDelete()
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })

    },

    edit() {
          this.form = idx;
          this.form.saveButton = "Kemaskini";
          this.dialog.show = true
      },

      katalogPrint() {
        window.open(
          this.api_service + 'lookup/cetak_katalog_stpp?cetak=1','_blank');
      },



    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },
    cetak() {
      window.location.href = window.route('se.stpp_katalog.index')+'?kode='+this.pencarian.kode+'&lkp_ternakan_id='+this.pencarian.lkp_ternakan_id+'&lkp_baka_id='+this.pencarian.lkp_baka_id+'&cetak=1';
    },




  
  },

  watch: {

  },
  mounted() {
   this.getTernakan();
   this.getJantina();
   this.getBaka();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>
